/**
 * 尾牙抽籤獎項配置
 * 
 * 每個獎項只需設定 4 個欄位：
 * - name: 籤的名稱（2-6 字最佳）
 * - message: 籤的詳細內容（10-30 字）
 * - weight: 中獎權重（數字越大越容易中）
 * - tier: 稀有度等級（'SSR' | 'SR' | 'R' | 'N'）
 */

export const LUCKY_DRAW_PRIZES = [
  {
    name: '超稀有獎',
    message: '✨恭喜獲得史萊姆獎✨\n憑此截圖找史萊姆兌換星巴克 乙 杯\n(同一人唯一性)',
    weight: 1,
    tier: 'SSR'
  },
  {
    name: '頭獎',
    message: '💰 獲得獎金 30000 元！',
    weight: 2,
    tier: 'SSR'       // 超稀有（金光特效）
  },
  {
    name: '貳獎',
    message: '💰 獲得獎金 20000 元！',
    weight: 5,
    tier: 'SR'        // 稀有（紅色煙火）
  },
  {
    name: '參獎',
    message: '💰 獲得獎金 10000 元！',
    weight: 5,
    tier: 'SR'
  },
  {
    name: '肆獎',
    message: '💰 獲得獎金 2000 元！',
    weight: 8,
    tier: 'R'         // 罕見（藍色閃光）
  },
  {
    name: '伍獎',
    message: '💰 獲得獎金 1000 元！',
    weight: 10,
    tier: 'R'
  },
  {
    name: '陸獎',
    message: '💰 獲得獎金 500 元！',
    weight: 20,
    tier: 'R'
  },
  {
    name: '一般獎',
    message: '🧧 獲得7-11禮券 200 元！',
    weight: 24,
    tier: 'N'         // 普通（無特效）
  },
  {
    name: '安慰獎',
    message: '💪 明年再接再厲，好運即將到來！\n🫠快在尾牙前找 愛迪生 握手吧～',
    weight: 25,
    tier: 'N'
  }
];

// 稀有度配置（自動決定顏色和特效）
export const TIER_CONFIG = {
  SSR: {
    label: '超稀有',
    color: '#FFD700',
    glow: '#FFA500'
  },
  SR: {
    label: '稀有',
    color: '#FF6B6B',
    glow: '#FF0000'
  },
  R: {
    label: '罕見',
    color: '#4ECDC4',
    glow: '#00CED1'
  },
  N: {
    label: '普通',
    color: '#95E1D3',
    glow: '#3CB371'
  }
};
